import { Grid } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { prettifyDate } from "../../../helpers/prettify-date";
import { prettifyTime } from "../../../helpers/prettify-time";
import { HttpClient } from "../../../web-services/http-client";
import { objectToFormData } from "../../../web-services/utils/object-to-form-data";
import { DataGetterCard } from "../data-getter-card";
import { ProgressDialog } from "../progress-dialog";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ExportBlock(props: {
    httpClient: HttpClient;
    parkingLotId: number;
    selectedStartDate: Date;
    selectedStartTime: Date | undefined;
    selectedEndDate: Date;
    selectedEndTime: Date | undefined;
    selectedFormat: "csv" | "xlsx" | undefined;
    handleFormatChange: (val: "csv" | "xlsx" | undefined) => void;
    handleStartDateChange: (date: any) => void;
    handleStartTimeChange: (date: any) => void;
    handleEndDateChange: (date: any) => void;
    handleEndTimeChange: (date: any) => void;
})
{
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(false);
    const [progressDialogOpened, setProgressDialogOpened] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();
    const [errorCategoryMsg, setErrorCategoryMsg] = useState<string>();

    useEffect(() =>
    {
        if (props.selectedFormat === undefined) return;
        if (!isSendingRequest) return;
        setProgressDialogOpened(true);

        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                // TODO: change to /export-data API and decode the content
                let data = (await props.httpClient.post(
                    "values/export-data",
                    "",
                    objectToFormData({
                        parkingLotId: props.parkingLotId,
                        startDate: prettifyDate(props.selectedStartDate),
                        endDate: prettifyDate(props.selectedEndDate),
                        startTime: prettifyTime(props.selectedStartTime),
                        endTime: prettifyTime(props.selectedEndTime),
                        exportFormat: props.selectedFormat
                    }),
                    15000,
                    "blob"
                )) as any;

                const element = document.createElement("a");
                element.href = window.URL.createObjectURL(data.response);
                element.download = data.header;
                element.style.display = "none";
                document.body.appendChild(element);
                element.click();

                setProgressDialogOpened(false);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
            setIsSendingRequest(false);
        };

        fetchData().catch(console.error);

        setIsSendingRequest(false);
    }, [isSendingRequest]);

    return (
        // TODO: fix margins / padding since they are way too big.
        <>
            <ProgressDialog
                text="Exportálás folyamatban"
                retryButtonText="Újra lekérem"
                onRetryButtonClick={() => setIsSendingRequest(true)}
                onCancelButtonClick={() => setProgressDialogOpened(false)}
                retryButtonIcon={<Sync />}
                errorText={errorMsg}
                errorCategoryText={errorCategoryMsg}
                open={progressDialogOpened}
            />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <DataGetterCard
                        startDate={props.selectedStartDate}
                        startTime={props.selectedStartTime}
                        endDate={props.selectedEndDate}
                        endTime={props.selectedEndTime}
                        format={props.selectedFormat}
                        onFormatChange={props.handleFormatChange}
                        onButtonClick={() => setIsSendingRequest(true)}
                        onStartDateChange={props.handleStartDateChange}
                        onStartTimeChange={props.handleStartTimeChange}
                        onEndDateChange={props.handleEndDateChange}
                        onEndTimeChange={props.handleEndTimeChange}
                        mode="export"
                        modifiable={false}
                    />
                </Grid>
            </Grid>
        </>

    );
}
